import { axios } from './config'

export default {
  // oss埋点上传
  md: (dictionary) => axios.get(dictionary),

  // 获取给人信息
  getuserinfo: (json) => axios.post(Global_apiserver + 'api/user/getuserinfo', json),

  // 获取用户信息
  getUserInfoDiff: (json) => axios.post(Global_apiserver + 'api/user/v3/getUserInfoDiff', json),

  // 获取用户基本信息（轻量：姓名/头像/认证级别）
  getUserInfoBasic: (json) => axios.post(Global_apiserver + 'api/user/v3/getUserInfoBasic', json),

  // 是否完善信息
  checkInfoComplete: (json) => axios.post(Global_apiserver + 'api/user/checkInfoComplete', json),

  // 点赞
  socialextPraise: (json) => axios.post(Global_apiserver + 'community/socialext/praise', json),

  socialextGetcommentlist: (json) => axios.post(Global_apiserver + 'community/socialext/getcommentlist', json),

  // 删除动态
  deleteEditsocialext: (json) => axios.post(Global_apiserver + 'community/socialext/editsocialext', json),

  getsocialextdetail: (json) => axios.post(Global_apiserver + 'community/socialext/getsocialextdetail', json),

  // 关注发动态的医生
  followdoctor: (json) => axios.post(Global_apiserver + 'api/patient/followdoctor', json),

  // 关注动态
  followComment: (json) => axios.post(Global_apiserver + 'community/socialext/follow', json),

  // 评论/回复动态/设置为最佳/删评论
  communityComment: (json) => axios.post(Global_apiserver + 'community/socialext/comment', json),

  // 大咖列表
  aceUserList: (json) => axios.post(Global_apiserver + 'api/user/aceUserList', json),

  // 大咖主页
  getAceUserMainPage: (json) => axios.post(Global_apiserver + 'api/user/aceUserMainPage', json),

  // 获取动态列表
  getsocialextlist: (json) => axios.post(Global_apiserver + 'community/socialext/getsocialextlist', json),

  // 检查动态权限
  checkSocialGroupCommunityAuth: (json) => axios.post(Global_apiserver + 'api/user/checkSocialGroupCommentAuth', json),

  // 记录转发
  incrForward: (json) => axios.post(Global_apiserver + 'community/socialext/incrForward', json),

  // 专栏详情
  getColumnistBlockDetail: (json) => axios.post(Global_apiserver + 'api/doc/getColumnistBlockDetail', json),

  // 获取专栏ID
  getColumnistIdByUserId: (json) => axios.post(Global_apiserver + 'api/doc/getColumnistIdByUserId', json),

  // 获取社群专栏详情
  getcolumnistdetail: (json) => axios.post(Global_apiserver + 'api/pub/getcolumnistdetail', json),

  // 获取会议列表的分类
  getChooseChannels: (json) => axios.post(Global_apiserver + 'api/integrate/getChooseChannels', json),

  // 获取会议列表
  getMeetingList: (json) => axios.post(Global_apiserver + 'api/integrate/getIntegrateList', json),

  // 关注专题
  signup: (json) => axios.post(Global_apiserver + 'api/doc/signup', json),

  // 获取医院列表
  getLikeHospital: (json) => axios.post(Global_apiserver + 'api/pub/gethospitalsuggest', json),

  // 获取医生入驻申请情况
  repeatCheck: (json) => axios.post(Global_apiserver + 'api/dhDoctorApplication/repeatCheck', json),

  // 医生入驻
  addDhDoctorApplication: (json) => axios.post(Global_apiserver + 'api/dhDoctorApplication/addDhDoctorApplication', json),

  // 获取省市联动地址
  getAreaList: (json) => axios.post(Global_apiserver + 'api/pub/getArea', json),

  // 获取科室列表
  getDeptList: (json) => axios.post(Global_apiserver + 'api/consultation/getDeptByPlat', json),

  // 获取企业列表
  getcompanies: (json) => axios.post(Global_apiserver + 'api/enterprise/getenterpriselist', json),

  // 保存个人信息
  setuserinfo: (json) => axios.post(Global_apiserver + 'api/user/setuserinfo', json),

  // 选择身份
  choicerole: (json) => axios.post(Global_apiserver + 'api/user/choicerole', json),

  // 答题结果查询
  scoreRanks: (json) => axios.post(Global_apiserver + 'qa/clo/result/scoreRanks', json),

  // 活动详情（分享活动、成绩））
  qaEventInfo: (json) => axios.post(Global_apiserver + 'qa/clo/event/info', json),

  // 处方详情
  getPrescriptionById: (json) => axios.post(Global_apiserver + '/api/prescription/getPrescriptionById', json),

  // 用药频次
  getDrugUseRates: (json) => axios.post(Global_apiserver + '/api/prescription/getDrugUseRates', json),

  // 获取药品用法
  getDrugMethods: (json) => axios.post(Global_apiserver + '/api/prescription/getDrugMethods', json),

  // 获取药品列表
  getDrugs: (json) => axios.post(Global_apiserver + '/api/prescription/getDrugs', json),

  // 获取药品规格
  getDrugSpecsById: (json) => axios.post(Global_apiserver + '/api/prescription/getDrugSpecsById', json),

  // 药品详情
  getDrugDetail: (json) => axios.post(Global_apiserver + '/api/prescription/getDrugDetail', json),

  // 获取问诊的患者健康档案
  getPatientProfile: (json) => axios.post(Global_apiserver + '/api/prescription/getPatientProfile', json),

  // 开处方
  prescribing: (json) => axios.post(Global_apiserver + '/api/prescription/prescribing', json),

  // 是否审方药师 0 否 1 是
  getInquirySetting: (json) => axios.post(Global_apiserver + '/api/dhInquirySetting/getInquirySetting', json),

  // 药师审核处方
  pharmacistReview: (json) => axios.post(Global_apiserver + '/api/prescription/pharmacistReview', json),

  //问诊详情
  getInquiryById: (json) => axios.post(Global_apiserver + '/api/dhInquiry/getInquiryById', json),

  //josn接口
  getsavekey: (json) => axios.post(Global_nodeserver + '/tools/getsavekey', json),

  //更新擅长癌种
  askupdate: (json) => axios.post(H_APISERVER + 'ask/doctor/update', json),

  //判断是否有EDC权限（试登录）
  tryLogin: (json) => axios.post(Global_apiserver + 'api/edc/user/tryLogin', json),

  //EDC项目列表
  edcselectList: (json) => axios.post(Global_apiserver + '/api/edc/project/list', json),

  //EDC项目列表
  edcpatientList: (json) => axios.post(Global_apiserver + '/api/edc/patient/list', json),

  //EDC项目列表
  addPatientRecord: (json) => axios.post(Global_apiserver + '/api/edc/patient/addPatientRecord', json),

  //EDC添加新项目
  edcadd: (json) => axios.post(Global_apiserver + '/api/edc/project/add', json),

  //EDC项目可选模块
  edcmodules: (json) => axios.post(Global_apiserver + '/api/edc/project/modules', json),

  //EDC项目添加受试者
  edcaddPatient: (json) => axios.post(Global_apiserver + '/api/edc/patient/addPatient', json),

  //EDC项目历史列表
  edcgetPatientRecordList: (json) => axios.post(Global_apiserver + '/api/edc/patient/getPatientRecordList', json),

  //EDC获取源数据
  edcgetPatientRecordById: (json) => axios.post(Global_apiserver + '/api/edc/patient/getPatientRecordById', json),

  //EDC修改源数据
  edceditPatientRecord: (json) => axios.post(Global_apiserver + '/api/edc/patient/editPatientRecord', json),

  //EDC认证详情
  edcgetCert: (json) => axios.post(Global_apiserver + 'api/edc/user/getCert', json),

  //EDC科研认证提交信息
  uploadEdcDoctorVerify: (json) => axios.post(Global_apiserver + '/api/edc/user/submitCert', json),

  // EDC 获取受试者信息
  getPatientInfoById: (formData) => axios.post(`${Global_apiserver}api/edc/patient/getPatientById`, formData),
  // 获取认证图片
  getRenzhengPic: (json) => axios.post(Global_apiserver + 'api/user/downloadidcards', json),

  // 判断是否开通某平台
  isOpenPlat: (json) => axios.post(Global_apiserver + 'api/wb/checkOpenStatus', json),
  //获取会议视频
  getVideoMeetingChannel: (json) => axios.post(Global_apiserver + 'api/meeting_n/getMeetingChannel', json),
  //since 9.2 获取会议频道列表
  getMeetingPageChannel: (json) => axios.post(Global_apiserver + 'api/channel/getMeetingPageChannel', json),
  //since 9.2 获取选中日期当天会议列表
  getMeetingByToday: (json) => axios.post(Global_apiserver + 'api/meeting/getMeetingByToday', json),
  //获取当天的会议视频
  getVideoMeetingByToday: (json) => axios.post(Global_apiserver + 'api/meeting_n/getMeetingByToday', json),
  //获取会议视频的日期
  getVideoMeetingCalendar: (json) => axios.post(Global_apiserver + 'api/meeting_n/getMeetingCalendar', json),
  //since 9.2 获取有会议的日期
  getMeetingCalendar: (json) => axios.post(Global_apiserver + 'api/meeting/getMeetingCalendar', json),
  //since 9.2 今日会议前三条 / 会议日历非当天会议
  getMeetingByTimes: (json) => axios.post(Global_apiserver + 'api/meeting/getMeetingByTimes', json),
  //获取非当天的会议视频
  getVideoMeetingByTimes: (json) => axios.post(Global_apiserver + 'api/meeting_n/getMeetingByTimes', json),
  // 获取快速问诊详情
  getFastQueryDetail: (json) => axios.post(Global_apiserver + 'api/quickAnswer/detail', json),

  // 快速问诊详情--接诊
  acceptFastQuery: (json) => axios.post(Global_apiserver + 'api/quickAnswer/accept', json),

  // 快速问诊详情--退诊
  denyFastQuery: (json) => axios.post(Global_apiserver + 'api/quickAnswer/refuse', json),

  // 上传小结（快速问诊）
  uploadSummaryQuery: (json) => axios.post(Global_apiserver + 'api/quickAnswer/uploadAdvice', json),

  // 获取患者疾病编码
  getPatDiseaseCode: (json) => axios.post(Global_apiserver + 'api/dhMedicalRecord/diseaseCode', json),

  // 获取病历详情
  getPatDiseaseDetail: (json) => axios.post(Global_apiserver + 'api/dhMedicalRecord/detail', json),

  // 开病历
  openPatCase: (json) => axios.post(Global_apiserver + 'api/dhMedicalRecord/openRecord', json),

  // 接诊退诊（图文）
  dealIhInquiryStatus: (json) => axios.post(Global_apiserver + 'api/dhInquiry/updateInquiry', json),

  // 视频问诊详情
  getVideoQueryDetail: (json) => axios.post(Global_apiserver + 'api/dhVideo/getApiVideoById', json),

  /**
   * 公开课-笔记-获取上传授权配置
   */
  getNoteUploadUrl: (json) => axios.post(Global_apiserver + 'api/note/getUploadUrl', json),
  /**
   * 公开课-笔记-保存笔记
   */
  saveNote: (json) => axios.post(Global_apiserver + 'api/note/saveNote', json),
  /**
   * 公开课-笔记-我的笔记数量
   */
  getNoteAccount: (json) => axios.post(Global_apiserver + 'api/note/getNoteAccount', json),
  /**
   * 公开课-笔记-笔记列表
   */
  getNoteList: (json) => axios.post(Global_apiserver + 'api/note/getNoteList', json),
  /**
   * 普通的get请求
   */
  get: (url) => axios.get(url),
  /**
   * 公开课-笔记-笔记列表-删除笔记
   */
  delNoteById: (json) => axios.post(Global_apiserver + 'api/note/delNoteById', json),
  /**
   * 公开课-笔记-笔记列表-编辑笔记
   */
  getNoteById: (json) => axios.post(Global_apiserver + 'api/note/getNoteById', json),

  /**
   * 获取用户的IM的信息
   */
  getUserTimInfo: (json) => axios.post(Global_apiserver + 'api/im/loadAccount', json),

  /**
   * app-肿瘤医生客服回复列表
   */
  getMessageListAfter47: (json) => axios.post(Global_apiserver + 'api/mymessage/messagelistafter47', json),

  /**
   * @since 9.5 sprint2
   * 任务中心 金刚区配置
   */
  getMyTaskNaviConfig: () => axios.get(Global_AliJson_path + 'mytask_navi_config'),
  /**
   * @since 9.5 sprint2
   * 公共获取广告接口
   * json:{
   *   head,
   *   actionType:20//任务中心胶囊广告
   * }
   */
  getAdvertise: (json) => axios.post(Global_apiserver + 'api/pub/getadvertise', json),
  /**
   * @since 9.5 sprint2
   * 签到组件-配置接口
   * json:{
   *   head,
   *   code:"ZSIN20230315908"
   * }
   */
  getSignInConfig: (json) => axios.post(Global_apidtserver + 'mc/cmpt/signIn/getSignInConfig', json),
  /**
   * @since 9.5 sprint2
   * 签到组件-签到接口
   * json:{
   *   head,
   *   code:"ZSIN20230315908"
   * }
   */
  getSignInCheckInt: (json) => axios.post(Global_apidtserver + 'mc/cmpt/signIn/checkIn', json),
  /**
   * @since 9.5 sprint2
   * 签到组件-week数据
   * json:{
   *   head,
   *   code:"ZSIN20230315908"
   * }
   */

  getSignInWeekDate: (json) => axios.post(Global_apidtserver + 'mc/cmpt/signIn/getWeekDate', json),
  /**
   * @since 9.5 sprint2
   * 签到组件-月日历数据
   * json:{
   *   head,
   *   code:"ZSIN20230315908"
   * }
   */

  getSignInMonthRecord: (json) => axios.post(Global_apidtserver + 'mc/cmpt/signIn/getMonthRecord', json),
  /**
   * @since 9.5 sprint2
   * 签到组件-连续签到奖励信息
   * json:{
   *   head,
   *   code:"ZSIN20230315908",
   *   id:Number
   * }
   */
  getStageRewardInfo: (json) => axios.post(Global_apidtserver + 'mc/cmpt/signIn/getStageRewardInfo', json),
  /**
   * @since 9.5 sprint2
   * 根据任务对象获取任务触发体
   * json:{
   *   head,
   *   targetCode:String,//任务对象code值  : 详情
                           https://liangyihui.feishu.cn/wiki/wikcnuuVCyEZyhuyMb41ZKvtQZd#SequdQQOuoqks2xUlkDc8HRsnsf
                           签到：msign
                           文章：mdoc  -- 阅读、观看、评论、留言
                           专栏：mcol   -- 关注
                           动态：msoc  -- 发动态
                           答题：mans  -- 答题
                           工具：mtol   -- 浏览工具、使用工具
                           用户：muser -- 注册、认证、完善、邀请
                           通用：mcom -- 分享
                           外链：mElink -- 浏览、外链
   *   targetId:Number,//任务对象id，
                         用于过滤用户已经完成的任务
                         文章id;专栏id；试卷id，社群id，组件id

   *   taskCode:String,//任务  mcode，从任务列表进入必填
   *   userId:String,//用户ID，没有auth时传此参数
   * }
   */
  getTaskCondititons: (json) => axios.post(Global_apidtserver + 'mc/task/getConditionByCode', json),
  /**
   * @since 9.5 sprint2
   * 完成任务接口
   * json:{
   *   head,
   *   taskCode:String,//任务  mcode，从任务列表进入必填
   *   userType:Number,//用户类型，1：肿瘤医生
   *   associationId:Number,//任务对象id
   *   userId:String,//用户ID，没有auth时传此参数
   * }
   */
  setTaskDoneMission: (json) => axios.post(Global_apidtserver + 'mc/task/doneMission', json),

   /**
   * @since 9.5 sprint2
   * 完成任务接口
   * json:{
   *   head,
   *   targetId:Number,//任务对象id，
                         用于过滤用户已经完成的任务
                         文章id;专栏id；试卷id，社群id，组件id
       taskType:Array,
   *   taskCode:String,//任务  mcode，从任务列表进入必填
   * }
   */
   getTaskByTarget: (json) => axios.post(Global_apidtserver + 'mc/task/getTaskByTarget', json),

  /**
   * @since 9.5.6
   */
  getAppMarketReviewClassConfig: () => axios.get(Global_AliJson_path + 'for_app_market_review_config'),

  /**
   * 会议视频--预约
   */
  doAppointMeetingVideo: (json) => axios.post(Global_apiserver + 'api/document/documentSub',json),

  /**
   * 关注专栏、专题后进行订阅设置
   */
  setSubscribePush: (json) => axios.post(Global_apiserver + 'api/pub/setSubscribeStatus', json),

  /**
   * 预约直播后进行订阅设置
   */
  setSubscribeLivePush: (json) => axios.post(Global_apiserver + 'api/document/setSubscribeStatus', json),

  /**
   * 新医生主页-获取用户信息接口
   * json:{
   *  head,
   *  sourceType                            1：医生端，2：研值圈
   *  researcherUuid
   *  researcherProjectListLimit            研究的项目展示数量
   *  documentRelateListLimit               医生绑定的专栏专题集合展示数量
   *  researcherCooperateGroupListLimit     研究协作组展示数量
   * }
   */
  getResearcherInfo: (json) => axios.post(Global_apiserver + 'api/doctorHomePage/queryResearcherHomePage', json),

  /**
   * 获取七牛token
   *
   */
  getqiniutoken: (json) => axios.post(Global_apiserver + 'api/pub/getqiniuuploadtoken', json),

  // 获取七牛上传文件后的地址
  getqiniuurl: (json) => axios.post(Global_apiserver + 'api/pub/getqiniupicurl', json),

  // 上传七牛华东区空间
  uploadqiniu: (formDataJson) => axios.post('https://upload.qiniup.com', formDataJson),

  // 获取瘤种
  getDiseaseList: (json) => axios.post(Global_apiserver + 'api/doctorHomePage/queryDiseasePage', json),

  // 医生排班
  getDoctorDuty: (json) => axios.post(Global_apiserver + 'api/doctorHomePage/queryDoctorDuty', json),

  // 提交会诊申请表单
  postConsultationDoctor: (json) => axios.post(Global_apiserver + 'api/doctorHomePage/consultationDoctor', json),

  // 关注或者取消关注
  setFollows: (json) => axios.post(Global_apiserver + 'api/doctorHomePage/setFollows', json),

  // 获取研究者的文章列表
  getDoctorArticleList: (json) => axios.post(Global_apiserver + 'api/doctorHomePage/queryResearcherDocument', json),
  /**
   * @since 9.7 sprint1
   * 完成任务接口
   * json:{
   *   head,
   *   buzCode:String,//业务编码code，全局唯一
   *   buzVersion:String,//业务模块版本
   *   buzGuide:Number,//1:完成新手引导时上报
   * }
   */
  postPubGuide: (json) => axios.post(Global_apidtserver + '/api/pub/guide', json),

  /**
   * 罗氏BC医路行
   * 分享积分排行榜
   */
  getBCLSshareranks: (json) => axios.post(Global_apidtserver + 'activity/api/ls2024as/shareRanks', json),

  /**
   * 罗氏BC医路行
   * 积分排行榜
   */
  getBCLSranks: (json) => axios.post(Global_apidtserver + 'activity/api/ls2024as/ranks', json),

  /**
   * 罗氏BC医路行
   * 获取用户信息
   */
  getBCLSUserInfo: (json) => axios.post(Global_apidtserver + 'activity/api/ls2024user/getUserInfo', json),

  /**
   * 罗氏BC医路行
   * 我的剩餘積分
   */
  getBCLSResidualScore: (json) => axios.post(Global_apidtserver + 'activity/api/ls2024as/residualScore', json),

  /**
   * 罗氏BC医路行
   * 完成阅读任务
   */
  getBCLSReadDocScore: (json) => axios.post(Global_apidtserver + 'activity/api/ls2024as/finish', json),

  /**
   * 罗氏BC医路行
   * 获取json
   */
  getBCLSJsonData: (e) => axios.get(Global_AliJson_path + e),

  /**
   * 罗氏BC医路行
   * 获取任务进度比例
   */
  getBCLSActivityProgress: (json) => axios.post(Global_apidtserver + 'activity/api/ls2024as/progress', json),

  /**
   * 罗氏BC医路行
   * 申请二次认证
   */
   getBCLActivityApply: (json) => axios.post(Global_apidtserver + 'activity/api/ls2024as/apply', json),


  /**
   * 罗氏BC医路行
   * check是否需要二次认证
   */
  getBCLSActivityCheckApply: (json) => axios.post(Global_apidtserver + 'activity/api/ls2024as/checkApply', json),

  /**
   * 罗氏BC医路行
   * 获取专题|专栏下的文章id
   */
  getBCLSRemixIds: (json) => axios.post(Global_apidtserver + 'activity/api/ls2024as/getRemixIds', json),

  /**
   * 罗氏BC医路行
   * 获取二次认证
   */
  getBCLSSecondCheck: (json) => axios.post(Global_apidtserver + 'activity/api/ls2024user/secondCheck', json),

  /**
   * 罗氏BC医路行
   * 活动积分完成
   */
  postBCLSFinishDoc: (json) => axios.post(Global_apidtserver + 'activity/api/ls2024as/finish', json),

  /**
   * 罗氏BC医路行
   * 我的收藏
   */
  getBCLSMyCollection: (json) => axios.post(Global_apidtserver + 'activity/api/ls2024doc/myCollection', json),

  /**
   * 罗氏BC医路行
   * 取消我的收藏
   */
  postBCLSCancelMyCollection: (json) => axios.post(Global_apidtserver + 'activity/api/ls2024doc/delMyCollect', json),

  /**
   * 罗氏BC医路行
   * 我的阅读历史
   */
  getBCLSMyReadHistory: (json) => axios.post(Global_apidtserver + 'activity/api/ls2024doc/history', json),

  /**
   * under35海报项目
   * 2024-04-16
   * 获取海报内容
   */
  getUnderQrCode: (json) => axios.post(Global_apidtserver + 'activity/api/u35u2024/qrCode', json),

  /**
   * 2024WCLC项目
   * 2024-08-07
   * 获取大会日程
   */
  getWclcScheduleList: (json) => axios.post(Global_apidtserver + 'activity/api/wclc2024/schedule', json),

  /**
   * 2024WCLC项目
   * 2024-08-07
   * 获取直播文章
   */
  getWclcLiveDoc: (json) => axios.post(Global_apidtserver + 'activity/api/wclc2024/liveDoc', json),

  /**
   * 2024WCLC项目
   * 2024-08-07
   * 订阅会议
   */
  postWclcSubscribeLiveDoc: (json) => axios.post(Global_apidtserver + 'activity/api/wclc2024/subscribe', json),

  /**
   * 2024WCLC项目
   * 2024-08-07
   * 关注-取消关注session
   */
  postWclcFollow: (json) => axios.post(Global_apidtserver + 'activity/api/wclc2024/follow', json),

  /**
   * 2024WCLC项目
   * 2024-08-07
   * 我的预约文章
   */
  getWclcFollowDocList: (json) => axios.post(Global_apidtserver + 'activity/api/wclc2024/getMySubscribe', json),

  /**
   * 2024WCLC项目
   * 2024-08-07
   * 我的关注session
   */
  getWclcFollowList: (json) => axios.post(Global_apidtserver + 'activity/api/wclc2024/getMyFollow', json),

  /**
   * 2024WCLC项目
   * 2024-08-15
   * 获取剩余投票数
   */
  getWclcVoteCount: (json) => axios.post(Global_apidtserver + 'activity/api/wclc2024/literature/checkVote', json),

  /**
   * 2024WCLC项目
   * 2024-08-15
   * 获取热榜文献列表
   */
  getWclcLiteratureList: (json) => axios.post(Global_apidtserver + 'activity/api/wclc2024/literature/list', json),

  /**
   * 2024WCLC项目
   * 2024-08-15
   * 投票
   */
  postWclcVote: (json) => axios.post(Global_apidtserver + 'activity/api/wclc2024/literature/vote', json),

  /**
   * 2024WCLC项目
   * 2024-08-15
   * 分享标记
   */
  postWclcAddShareNum: (json) => axios.post(Global_apidtserver + 'activity/api/wclc2024/literature/share', json),

  /**
   * 2024WCLC项目
   * 2024-08-15
   * 一键关注
   */
  postWclcOneClick: (json) => axios.post(Global_apidtserver + 'activity/api/wclc2024/oneClick', json),

  /**
   * 2024ESMO项目
   * 2024-08-20
   * 获取剩余投票数
   */
  getEsmoVoteCount: (json) => axios.post(Global_apidtserver + 'activity/api/esmo2024/literature/checkVote', json),

  /**
   * 2024ESMO项目
   * 2024-08-20
   * 获取热榜文献列表
   */
  getEsmoLiteratureList: (json) => axios.post(Global_apidtserver + 'activity/api/esmo2024/literature/list', json),

  /**
   * 2024ESMO项目
   * 2024-08-20
   * 投票
   */
  postEsmoVote: (json) => axios.post(Global_apidtserver + 'activity/api/esmo2024/literature/vote', json),

  /**
   * 2024ESMO项目
   * 2024-08-20
   * 分享标记
   */
  postEsmoAddShareNum: (json) => axios.post(Global_apidtserver + 'activity/api/esmo2024/literature/share', json),

  /**
   * 2024ESMO项目
   * 2024-08-26
   * 获取大会日程
   */
  getEsmoScheduleList: (json) => axios.post(Global_apidtserver + 'activity/api/esmo2024/schedule', json),

  /**
   * 2024ESMO项目
   * 2024-08-26
   * 获取直播文章
   */
  getEsmoLiveDoc: (json) => axios.post(Global_apidtserver + 'activity/api/esmo2024/liveDoc', json),

  /**
   * 2024ESMO项目
   * 2024-08-26
   * 订阅会议
   */
  postEsmoSubscribeLiveDoc: (json) => axios.post(Global_apidtserver + 'activity/api/esmo2024/subscribe', json),

  /**
   * 2024ESMO项目
   * 2024-08-27
   * 一键关注
   */
  postEsmoOneClick: (json) => axios.post(Global_apidtserver + 'activity/api/esmo2024/oneClick', json),

  /**
   * 2024ESMO项目
   * 2024-08-27
   * 关注-取消关注session
   */
  postEsmoFollow: (json) => axios.post(Global_apidtserver + 'activity/api/esmo2024/follow', json),

  /**
   * 2024ESMO项目
   * 2024-08-27
   * 我的预约文章
   */
  getEsmoFollowDocList: (json) => axios.post(Global_apidtserver + 'activity/api/esmo2024/getMySubscribe', json),

  /**
   * 2024ESMO项目
   * 2024-08-27
   * 我的关注session
   */
  getEsmoFollowList: (json) => axios.post(Global_apidtserver + 'activity/api/esmo2024/getMyFollow', json),

  /**
   * 病例库
   * 2024-11-29
   * 病例库 json
   */
  caseBankJson: () => axios.get(Global_AliJson_path+ 'json/CaseBank?t=' + Date.now(),{ isJson: true }),

  /**
   * 病例库
   * 2024-11-29
   * 我的发布
   */
  myCaseList: (json) => axios.post(Global_apidtserver + 'api/v1/caseFolder/queryMyCaseFolderList',json),

  /**
   * 病例库
   * 2024-11-29
   * 我的草稿列表
   */
  myDraftList: (json) => axios.post(Global_apidtserver + 'api/v1/caseFolder/queryDraftsList',json),

  /**
   * 病例库
   * 2024-11-29
   * 我的草稿数量
   */
  myDraftsCount: (json) => axios.post(Global_apidtserver + 'api/v1/caseFolder/queryDraftsCount',json),

  /**
   * 病例库
   * 2024-11-29
   * 删除草稿病例文章
   */
  deleteDraft: (json) => axios.post(Global_apidtserver + 'api/v1/caseFolder/deleteDrafts',json),

  /**
   * 病例库
   * 2024-11-29
   * 病例广场 tab 集合
   */
  doctorCaseSelect: (json) => axios.post(Global_apidtserver + 'api/v1/caseFolder/getCaseSelect', json),

  /**
   * 病例库
   * 2024-11-29
   * 是否存在文章
   */
  doctorCaseexists: (json) => axios.post(Global_apidtserver + 'api/v1/documentBasic/rareCase/exists',json),

    /**
   * 病例库
   * 2024-11-29
   * tab
   */
    doctorNewCaseList: (json) => axios.post(Global_apidtserver + 'api/v1/caseFolder/queryBasicCaseList',json),

  /**
   * 2024年人年度报告
   * 2025-01-13
   */
  getStatistics2024: (json) => axios.post(Global_apidtserver + 'activity/api/appUser2024Review/getStatistics', json),

  /**
   * 2024年人年度报告--抽签页
   * 抽签
   * 2025-01-16
   */
  postDrawLuck: (json) => axios.post(Global_apidtserver + 'activity/api/appUser2024Draw/luck', json),

  /**
   * 2024年人年度报告--抽签页
   * 抽签次数
   * 2025-01-16
   */
  getDrawLuckCount: (json) => axios.post(Global_apidtserver + 'activity/api/appUser2024Draw/getDrawNum', json),

  /**
   * 2024年人年度报告--抽签页
   * 投票分享
   * 2025-01-16
   */
  postDrawLuckShare: (json) => axios.post(Global_apidtserver + 'activity/api/appUser2024Draw/drawShare', json),

  /**
   * 2024年人年度报告--抽签页
   * 活动是否结束
   * 2025-01-16
   */
  getDrawLuckClose: (json) => axios.post(Global_apidtserver + 'activity/api/appUser2024Draw/isLive', json),

  /**
   * 资讯增加MedSeek解读
   * 获取解读内容和思考过程
   * 2025-02-20
   */
  getAIinterpretation: (id, json) => axios.post(Global_apidtserver + 'api/v1/interpretation/getById/' + id, json),

  /**
   * 智例会
   * 判断是否已经立即参与过
   * 2025-04-15
   */
  checkCaseprojectPop: (json) => axios.post(Global_apiserver + 'activity/api/caseproject/pop/check', json),

  /**
   * 智例会
   * 立即参与进行上报
   * 2025-04-15
   */
  postCheckCaseprojectSave: (json) => axios.post(Global_apiserver + 'activity/api/caseproject/pop/save', json),

  /**
   * 默克2025
   * 排行榜-学习时长榜
   * 2025-04-25
   */
  getStudyTimeRanking: (json) => axios.post(Global_ActivetyApiServer + 'api/moke2025/duration/rank', json),

  /**
   * 默克2025
   * 排行榜-成绩榜
   * 2025-04-25
   */
  getScoreRanking: (json) => axios.post(Global_ActivetyApiServer + 'api/moke2025/score/rank', json),

  /**
   * 获取病例库json数据
   */
  getPatCasesData: () => axios.get(Global_AliJson_path + 'doctor_patcases'),

  /**
   * 2025年人年度报告
   * 2025-12-11
   */
  getStatistics2025: (json) => axios.post(Global_apidtserver + 'activity/api/appUser2025/getStatistics', json),

  /**
   * 2025年人年度报告--抽签页
   * 抽签
   * 2025-12-11
   */
  postDrawLuck2025: (json) => axios.post(Global_apidtserver + 'activity/api/appUser2025Draw/luck', json),

  /**
   * 2025年人年度报告--抽签页
   * 活动是否结束
   * 2025-12-11
   */
  getDrawLuckClose2025: (json) => axios.post(Global_apidtserver + 'activity/api/appUser2025Draw/isLive', json),

  /**
   * 2025年人年度报告--抽签页
   * 抽签次数
   * 2025-12-11
   */
  getDrawLuckCount2025: (json) => axios.post(Global_apidtserver + 'activity/api/appUser2025Draw/getDrawNum', json),

  /**
   * 2025年人年度报告--抽签页
   * 投票分享
   * 2025-12-11
   */
  postDrawLuckShare2025: (json) => axios.post(Global_apidtserver + 'activity/api/appUser2025Draw/drawShare', json),

  /**
   * 2025年人年度报告
   * 保存年度形象
   * 2025-12-11
   */
  cacheAnnualPersona: (json) => axios.post(Global_apidtserver + 'activity/api/appUser2025/cacheAnnualPersona', json),
  /**
   * 荟萃调研项目病例
   */   
  queryHcCaseList: (json) => axios.post(Global_apidtserver + '/api/v1/caseFolder/queryHcCaseList', json),

  /**
   * 咖啡券活动-页面初始化状态
   * GET /activity/api/coffee/activities/{id}/state
   */
  coffeeGetState: (id, params) => axios.get(Global_apidtserver + `activity/api/coffee/activities/${id}/state`, { params }),

  /**
   * 咖啡券活动-参与登记
   * POST /activity/api/coffee/activities/{id}/participants
   * params 为 query（auth 鉴权串）
   */
  coffeeParticipate: (id, data, params) => axios.post(Global_apidtserver + `activity/api/coffee/activities/${id}/participants`, data, { params }),

  /**
   * 咖啡券活动-去喝一杯跳转上报
   * POST /activity/api/coffee/activities/{id}/redemption-goto
   */
  coffeeRedemptionGoto: (id, data, params) => axios.post(Global_apidtserver + `activity/api/coffee/activities/${id}/redemption-goto`, data, { params }),

  /**
   * 咖啡券活动-兑换券列表
   * GET /activity/api/coffee/activities/{id}/coupons
   */
  coffeeGetCoupons: (id, params) => axios.get(Global_apidtserver + `activity/api/coffee/activities/${id}/coupons`, { params }),
}
